import { render, staticRenderFns } from "./ClinicData.vue?vue&type=template&id=5e42962e&scoped=true&"
import script from "./ClinicData.vue?vue&type=script&lang=js&"
export * from "./ClinicData.vue?vue&type=script&lang=js&"
import style0 from "./ClinicData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClinicData.vue?vue&type=style&index=1&id=5e42962e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42962e",
  null
  
)

export default component.exports